<qpoint-map 
    [center]="mapMarkerOptions[0] ? {lat: mapMarkerOptions[0].position.lat, lng: mapMarkerOptions[0].position.lng} : {lat: 47, lng: 8}"
    [enableFullscreenControl]="true"
    [zoom]="15"
    [setZoomLevelOnFitBounds]="true"
    [stopFitToBoundsOnManualInteraction]="true"
    [zoomPosition]="zoomPosition"
    [minZoom]="0"
    [minZoomToShowLabels]="12"
    [gestureHandling]="'greedy'">

    <qpoint-map-marker *ngFor="let markerOption of mapMarkerOptions" [options]="markerOption"></qpoint-map-marker>
    <qpoint-map-polyline [polyline]="pavingPath"></qpoint-map-polyline>
    <qpoint-map-polygon [polygon]="siteArea"></qpoint-map-polygon>
    <qpoint-map-polygon [polygon]="plantArea"></qpoint-map-polygon>
</qpoint-map>